import {spacing} from '@logistics-frontend/blocks/theme/theme'

/** Высота дровера с адресом */
export const ADDRESS_INFO_CONTAINER_HEIGHT_IN_PX: string = spacing(25.75) // 206px

/** Скорость анимаций на карте */
export const MAP_ANIMATION_DURATION_IN_MS: number = 200
